import { UPDATE_SEARCHTDATA_HOPDONGDELETE } from "../../actions/DanhSachHopDongDelete/actionTypes";

const initialState = {
  NameCus: "",
  NameNQL: "0",
  DiaChi: "",
  SDT: "",
  SoTienVay: "",
  KieuVayID: "0",
  dateFrom: "01/01/2001",
  dateTo: "01/01/4000",
  NguoiXoa: "",
  pageIndex: 1,
  pageSize: 20,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchHopDongDelete = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_HOPDONGDELETE:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchHopDongDelete;
